import { defineComponent as _defineComponent } from 'vue'
import ChipButton from '@/ui-components/ChipButton.vue';
import { faMinusCircle, faCheck } from '@fortawesome/free-solid-svg-icons';
import { jwCheckIcon } from '@/plugins/global-fontawesome';


export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleButton',
  props: {
    active: { type: Boolean, default: false },
    negative: { type: Boolean, default: false },
    icon: null,
    noBorders: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const ICONS = {
	'minus-circle': faMinusCircle,
	'jw-check-icon': jwCheckIcon,
	check: faCheck,
};



return { __sfc: true,ICONS, ChipButton }
}

})